﻿(function ($) {
    $.fn.AreaMap = function (methodOrOptions) {

        var methods = {
            init: _init,
            zoom: _zoom,
            mapType: _mapType,
            resize: _resize,
        };


        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Error : Invalid Operation ' + methodOrOptions + ' for AgoraMap ');
        }

        function _resize() {
            var _self = $(this).data('AgoraMap');
            _self.Resize();
        };

        function _zoom(value) {
            var _self = $(this).data('AgoraMap');
            _self.Zoom(value);
        };

        function _mapType(value) {
            var _self = $(this).data('AgoraMap');
            _self.MapType(value);
        };

        function _init(options) {
            ///Declarations
            var _self = this;
            _self.$map = $(this);

            _self.Latitude = _self.$map.data('latitude');
            _self.Longitude = _self.$map.data('longitude');
            _self.MapIconnHref = _self.$map.data('map-pin');
            _self.POI = _self.$map.data('poi');
            _self.Address = _self.$map.data('address');
            _self.Markers = [];
            _self.POIService = null;
            _self.zoom_handler = null;

            _self.$POIContext = _self.$map.find('.poi-context');

            _self.$mapType = _self.$map.find('.mapType');

            $(_self.$mapType).off('click').on('click', function () {
                var $this = $(this);
                if (!$this.hasClass('satelite')) {
                    _self._map.setMapTypeId('satellite');
                }
                else {
                    _self._map.setMapTypeId('roadmap');
                }
                $this.toggleClass('satelite');

            });

            _self._options = $.extend({
                zoom: (typeof (_self.$map.data('zoom')) != 'undefined' && _self.$map.data('zoom') != '' ? _self.$map.data('zoom') : 15),
                locationZoom: 13,
            }, options);



            _self.IsInitialized = false;

            ///End Declarations

            ///Definition

            _self.Zoom = function (value) {
                if (value == '+') {
                    var _zoom = _self._map.getZoom();
                    _self._map.setZoom(++_zoom);
                } else if (value == '-') {
                    var _zoom = _self._map.getZoom();
                    _self._map.setZoom(--_zoom);
                } else {
                    _self._map.setZoom(parseInt(value, 10));
                }
            };

            _self.Resize = function () {
                google.maps.event.trigger(_self._map, "resize");
            };

            _self.MapType = function (value) {
                _self._map.setMapTypeId(value);
            };

            _self.ShowPOI = function () {
                if (_self.$POIContext.hasClass('active'))
                    _self.$POIContext.removeClass('active');
                else
                    _self.$POIContext.addClass('active');
            };

            _self.getGeoCodeForAddress = function (address, callBack) {
                if (typeof (_self._geoCoder) == 'undefined' || _self._geoCoder == null) _self._geoCoder = new google.maps.Geocoder();
                _self._geoCoder.geocode({ 'address': address }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        callBack(results[0].geometry.location);
                    } else {
                        callBack(null);
                    }
                });
            };

            _self.initialize = function () {
                try {
                    if (_self.Latitude != undefined && _self.Longitude != undefined && _self.Address != undefined) {
                        if (_self.Latitude != "0" && _self.Longitude != "0")
                            _self.initMap(new google.maps.LatLng(_self.Latitude, _self.Longitude));
                        else if (_self.Address != null && _self.Address != '')
                            _self.getGeoCodeForAddress(_self.Address, function (point) {
                                _self.initMap(point);
                            });
                    }
                } catch (e) { }
            };

            _self.initMap = function (value) {
                var defaultStyle = [];
                var styles = [{ elementType: "geometry", stylers: [{ color: "#ebe3cd" }] }, { elementType: "labels.text.fill", stylers: [{ color: "#523735" }] }, { elementType: "labels.text.stroke", stylers: [{ color: "#f5f1e6" }] }, { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#c9b2a6" }] }, { featureType: "administrative.land_parcel", elementType: "geometry.stroke", stylers: [{ color: "#dcd2be" }] }, { featureType: "administrative.land_parcel", elementType: "labels", stylers: [{ visibility: "off" }] }, { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#ae9e90" }] }, { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] }, { featureType: "poi", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] }, { featureType: "poi", elementType: "labels.text", stylers: [{ visibility: "off" }] }, { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#93817c" }] }, { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#a5b076" }] }, { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#447530" }] }, { featureType: "road", elementType: "geometry", stylers: [{ color: "#f5f1e6" }] }, { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#fdfcf8" }] }, { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#f8c967" }] }, { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#e9bc62" }] }, { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#e98d58" }] }, { featureType: "road.highway.controlled_access", elementType: "geometry.stroke", stylers: [{ color: "#db8555" }] }, { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] }, { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#806b63" }] }, { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] }, { featureType: "transit.line", elementType: "labels.text.fill", stylers: [{ color: "#8f7d77" }] }, { featureType: "transit.line", elementType: "labels.text.stroke", stylers: [{ color: "#ebe3cd" }] }, { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] }, { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#b9d3c2" }] }, { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#92998d" }] }];
                 var noPOI = { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] };
               
                if (_self.haveOwnPOI()) defaultStyle.push(noPOI);
                if (isdarkmode != undefined && isdarkmode) defaultStyle = [{ elementType: "geometry", stylers: [{ color: "#212121" }] }, { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] }, { elementType: "labels.text.stroke", stylers: [{ "color": "#212121" }] }, { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] }, { featureType: "administrative.country", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] }, { featureType: "administrative.land_parcel", stylers: [{ "visibility": "off" }] }, { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] }, { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#2c2c2c" }] }, { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#8a8a8a" }] }, { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#373737" }] }, { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#3c3c3c" }] }, { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#4e4e4e" }] }, { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] }, { featureType: "transit", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] }, { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }] }, { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3d3d3d" }] }];
              
                var _mapOptions = {
                    zoom: _self._options.zoom,
                    center: value,
                    scrollwheel: false,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    panControl: false,
                    streetViewControl: true,
                    mapTypeControl: false,
                    disableDefaultUI: true,
                    minZoom: 2,
                    zoomControl: false,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.TOP_RIGHT,
                        style: google.maps.ZoomControlStyle.SMALL
                    },
                    styles: defaultStyle
                };
                _self._map = new google.maps.Map(_self.$map.find('.map-context').get(0), _mapOptions);
                _self.$map.find('[data-zoom-in]').off('click').on('click', function () { _self.Zoom('+'); });
                _self.$map.find('[data-zoom-out]').off('click').on('click', function () { _self.Zoom('-'); });
                _self.$map.find('[data-fullscreen]').off('click').on('click', function () {
                    if (_self.$map.hasClass('full-view')) {
                        _self.$map.removeClass('full-view'); $('body').removeClass('agora-map-full-view');
                    } else {
                        _self.$map.addClass('full-view'); $('body').addClass('agora-map-full-view');
                    }
                    _self.Resize();
                });
                _self.$map.find('[data-poi-toggle]').off('click').on('click', function () {
                    _self.ShowPOI();
                });
                _self.$map.find('[data-satelite-view]').off('click').on('click', function () {
                    var $this = $(this);
                    if (!_self.$map.hasClass('satelite')) {
                        _self.MapType('satellite');
                    }
                    else {
                        _self.MapType('roadmap');
                    }
                    _self.$map.toggleClass('satelite');
                });
                var _marker = new google.maps.Marker({
                    map: _self._map,
                    position: value,
                    icon: _self.MapIconnHref,
                });



                _self.Markers.push(_marker);

                _self.POIService = _self.enablePlacesService(value);

                _self.IsInitialized = true;

                _self.EnableActionListeners();

                _self.SubscribeAction();
            };

            _self.EnableActionListeners = function () {
                _self.addZoomHandler();
            };

            _self.DisableActionListeners = function () {
                _self.removeZoomHandler();
            };

            _self.addZoomHandler = function () {
                _self.zoom_handler = google.maps.event.addListenerOnce(_self._map, 'zoom_changed', function () { _self.addZoomHandler(); _self.zoomAction(); });
            };

            _self.removeZoomHandler = function () {
                try {
                    _self.zoom_handler.remove();
                } catch (e) { }
            };

            _self.zoomAction = function () {
                if (_self.haveOwnPOI() && _self.POIService != null)
                    _self.POIService.clear();

            };

            _self.SubscribeAction = function () {
                if (_self.IsInitialized) {
                    var initializeAction = _self.$map.data('on-initialized');
                    initializeAction();
                }
            };

            _self.haveOwnPOI = function () {
                return (typeof (_self.POI) != 'undefined' && _self.POI != null && _self.POI != '');
            };



            _self.enablePlacesService = function (location) {
                if (!_self.haveOwnPOI()) return;
                var _placeService = this;
                var service = new google.maps.places.PlacesService(_self._map);
                var placesMarkers = {};
                var placesInfoWindow = null;
                var poiItems = {};
                var poiItemsMaster = {
                    'default': { label: 'Default', icon: 'map-icon-postal-code' },
                    'accounting': { label: 'Accounting', icon: 'map-icon-accounting' },
                    'airport': { label: 'Airport', icon: 'map-icon-airport' },
                    'amusement_park': { label: 'Amusement Park', icon: 'map-icon-amusement-park' },
                    'aquarium': { label: 'Aquarium', icon: 'map-icon-aquarium' },
                    'art_gallery': { label: 'Art Gallery', icon: 'map-icon-art-gallery' },
                    'atm': { label: 'ATM', icon: 'map-icon-atm' },
                    'bakery': { label: 'Bakery', icon: 'map-icon-bakery' },
                    'bank': { label: 'Bank', icon: 'map-icon-bank' },
                    'bar': { label: 'Bar', icon: 'map-icon-bar' },
                    'beauty_salon': { label: 'Beauty Salon', icon: 'map-icon-beauty-salon' },
                    'bicycle_store': { label: 'Bicycle Store', icon: 'map-icon-bicycle-store' },
                    'book_store': { label: 'Book Store', icon: 'map-icon-book-store' },
                    'bowling_alley': { label: 'Bowling Alley', icon: 'map-icon-bowling-alley' },
                    'bus_station': { label: 'Bus Station', icon: 'map-icon-bus-station' },
                    'cafe': { label: 'Cafe', icon: 'map-icon-cafe' },
                    'campground': { label: 'Campground', icon: 'map-icon-campground' },
                    'car_dealer': { label: 'Car Dealer', icon: 'map-icon-car-dealer' },
                    'car_rental': { label: 'Car Rental', icon: 'map-icon-car-rental' },
                    'car_repair': { label: 'Car Repair', icon: 'map-icon-car-repair' },
                    'car_wash': { label: 'Car Wash', icon: 'map-icon-car-wash' },
                    'casino': { label: 'Casino', icon: 'map-icon-casino' },
                    'cemetery': { label: 'Cemetery', icon: 'map-icon-cemetery' },
                    'church': { label: 'Church', icon: 'map-icon-church' },
                    'city_hall': { label: 'City Hall', icon: 'map-icon-city-hall' },
                    'clothing_store': { label: 'Clothing Store', icon: 'map-icon-clothing-store' },
                    'convenience_store': { label: 'Convenience Store', icon: 'map-icon-convenience-store' },
                    'courthouse': { label: 'Courthouse', icon: 'map-icon-courthouse' },
                    'dentist': { label: 'Dentist', icon: 'map-icon-dentist' },
                    'department_store': { label: 'Department Store', icon: 'map-icon-department-store' },
                    'doctor': { label: 'Doctor', icon: 'map-icon-doctor' },
                    'electrician': { label: 'Electrician', icon: 'map-icon-electrician' },
                    'electronics_store': { label: 'Electronics Store', icon: 'map-icon-electronics-store' },
                    'embassy': { label: 'Embassy', icon: 'map-icon-embassy' },
                    'fire_station': { label: 'Fire Station', icon: 'map-icon-fire-station' },
                    'florist': { label: 'Florist', icon: 'map-icon-florist' },
                    'funeral_home': { label: 'Funeral Home', icon: 'map-icon-funeral-home' },
                    'furniture_store': { label: 'Furniture Store', icon: 'map-icon-furniture-store' },
                    'gas_station': { label: 'Gas Station', icon: 'map-icon-gas-station' },
                    'gym': { label: 'Gym', icon: 'map-icon-gym' },
                    'hair_care': { label: 'Hair Care', icon: 'map-icon-hair-care' },
                    'hardware_store': { label: 'Hardware Store', icon: 'map-icon-hardware-store' },
                    'hindu_temple': { label: 'Hindu Temple', icon: 'map-icon-hindu-temple' },
                    'home_goods_store': { label: 'Home Goods Store', icon: 'map-icon-shopping-mall' },
                    'hospital': { label: 'Hospital', icon: 'map-icon-hospital' },
                    'insurance_agency': { label: 'Insurance Agency', icon: 'map-icon-insurance-agency' },
                    'jewelry_store': { label: 'Jewelry Store', icon: 'map-icon-jewelry-store' },
                    'laundry': { label: 'Laundry', icon: 'map-icon-laundry' },
                    'lawyer': { label: 'Lawyer', icon: 'map-icon-lawyer' },
                    'library': { label: 'Library', icon: 'map-icon-library' },
                    'liquor_store': { label: 'Liquor Store', icon: 'map-icon-liquor-store' },
                    'local_government_office': { label: 'Local Government Office', icon: 'map-icon-local-government' },
                    'locksmith': { label: 'Locksmith', icon: 'map-icon-locksmith' },
                    'lodging': { label: 'Lodging', icon: 'map-icon-lodging' },
                    'meal_delivery': { label: 'Meal', icon: 'map-icon-restaurant' },
                    'meal_takeaway': { label: 'Meal', icon: 'map-icon-restaurant' },
                    'mosque': { label: 'Mosque', icon: 'map-icon-mosque' },
                    'movie_rental': { label: 'Movie Rental', icon: 'map-icon-movie-rental' },
                    'movie_theater': { label: 'Movie Theater', icon: 'map-icon-movie-theater' },
                    'moving_company': { label: 'Moving Company', icon: 'map-icon-moving-company' },
                    'museum': { label: 'Museum', icon: 'map-icon-museum' },
                    'night_club': { label: 'Night Club', icon: 'map-icon-night-club' },
                    'painter': { label: 'Painter', icon: 'map-icon-painter' },
                    'park': { label: 'Park', icon: 'map-icon-park' },
                    'parking': { label: 'Parking', icon: 'map-icon-parking' },
                    'pet_store': { label: 'Pet Store', icon: 'map-icon-pet-store' },
                    'pharmacy': { label: 'Pharmacy', icon: 'map-icon-pharmacy' },
                    'physiotherapist': { label: 'Physiotherapist', icon: 'map-icon-physiotherapist' },
                    'plumber': { label: 'Plumber', icon: 'map-icon-plumber' },
                    'police': { label: 'Police', icon: 'map-icon-police' },
                    'post_office': { label: 'Post Office', icon: 'map-icon-post-office' },
                    'real_estate_agency': { label: 'Real Estate Agency', icon: 'map-icon-real-estate-agency' },
                    'restaurant': { label: 'Restaurant', icon: 'map-icon-restaurant' },
                    'roofing_contractor': { label: 'Roofing Contractor', icon: 'map-icon-roofing-contractor' },
                    'rv_park': { label: 'RV Park', icon: 'map-icon-rv-park' },
                    'school': { label: 'School', icon: 'map-icon-school' },
                    'shopping_mall': { label: 'Shopping Mall', icon: 'map-icon-shopping-mall' },
                    'spa': { label: 'Spa', icon: 'map-icon-spa' },
                    'stadium': { label: 'Stadium', icon: 'map-icon-stadium' },
                    'storage': { label: 'Storage', icon: 'map-icon-storage' },
                    'shoe_store': { label: 'Shoe Store', icon: 'map-icon-store' },
                    'store': { label: 'Store', icon: 'map-icon-store' },
                    'subway_station': { label: 'Subway Station', icon: 'map-icon-subway-station' },
                    'supermarket': { label: 'Supermarket', icon: 'map-icon-grocery-or-supermarket' },
                    'synagogue': { label: 'Synagogue', icon: 'map-icon-synagogue' },
                    'taxi_stand': { label: 'Taxi Stand', icon: 'map-icon-taxi-stand' },
                    'train_station': { label: 'Train Station', icon: 'map-icon-train-station' },
                    'transit_station': { label: 'Transit Station', icon: 'map-icon-transit-station' },
                    'travel_agency': { label: 'Travel Agency', icon: 'map-icon-travel-agency' },
                    'veterinary_care': { label: 'Veterinary Care', icon: 'map-icon-veterinary-care' },
                    'zoo': { label: 'Zoo', icon: 'map-icon-zoo' },
                };


                function search(type) {
                    clearPlaceMarkers(type);
                    var searchLocation = _self._map.getBounds();
                    service.nearbySearch({ bounds: searchLocation, radius: 500, type: [type] }, function (results, status, pagination) { if (status !== 'OK') return; createMarkers(type, results); });

                }

                _placeService.clear = function () {
                    for (var key in poiItems) {
                        var poi = poiItems[key];
                        if (poi.isAllowed) {
                            poi.isAllowed = poi.actionItem[0].checked = false;
                            clearPlaceMarkers(poi.key);
                        }
                    }
                }

                function enableSearchableViews() {
                    if (_self._map.getZoom() < 14)
                        return;
                    _self.DisableActionListeners();
                    _self._map.setZoom(14);
                    _self.EnableActionListeners();
                }

                function createMarkers(type, places) {
                    for (var i = 0, place; place = places[i]; i++) {
                        createPlaceMarker(type, place);
                    }
                }

                function createPlaceMarker(type, p) {
                    var typesClasses = ' ' + type;
                    var poiItem = getPOIItem(type);
                    var placeMarker = new MarkerWithLabel({
                        position: p.geometry.location,
                        icon: '/images/c0.png',
                        labelContent: '<i class="map-icon ' + poiItem.icon + '"></i>',
                        labelInBackground: false,
                        labelClass: 'poi-marker' + typesClasses,
                        title: p.name,
                        placeId: p.place_id,
                        map: _self._map
                    });
                    google.maps.event.addListener(placeMarker, 'click', function () {
                        try {
                            placesInfoWindow.close();
                        } catch (e) { }
                        placesInfoWindow = new google.maps.InfoWindow();
                        service.getDetails({ placeId: placeMarker.placeId }, function (PlaceResult, PlacesServiceStatus) {
                            if (PlacesServiceStatus == 'OK') {
                                var PlaceAddr = (PlaceResult.formatted_address != undefined) ? PlaceResult.formatted_address : '';
                                var PlacePhone = (PlaceResult.formatted_phone_number != undefined) ? PlaceResult.formatted_phone_number : '';
                                var PlaceWeb = (PlaceResult.website != undefined) ? PlaceResult.website : '';
                                var PlaceUrl = (PlaceResult.url != undefined) ? PlaceResult.url : '';

                                var content = '';
                                content += '<div class="poi-info-window">';
                                content += '<a class="mdl-color-text--primary address"' + (PlaceUrl != null && PlaceUrl != '' ? ' href="' + PlaceUrl + '"' : '') + ' target="_blank"><b>' + placeMarker.title + '</b></a>';
                                if (PlaceAddr != null && PlaceAddr != '') content += '<i>' + PlaceAddr + '</i>';
                                content += '<div class="contact" data-value=\"' + PlacePhone + PlaceWeb + '\">'
                                if (PlacePhone != null && PlacePhone != '') content += '<a class="mdl-color-text--primary phone" data-material-icon="phone_iphone" href="tel:' + PlacePhone + '" target="_blank">Call</a>';
                                if (PlaceWeb != null && PlaceWeb != '') content += '<a class="mdl-color-text--primary website" data-material-icon="public" href="' + PlaceWeb + '" target="_blank">Website</a>';
                                content += '</div>';
                                content += '</div>';
                                placesInfoWindow.setContent(content);
                                placesInfoWindow.open(_self._map, placeMarker);
                            }
                        });
                    });
                    if (typeof (placesMarkers[type]) == 'undefined')
                        placesMarkers[type] = [];
                    placesMarkers[type].push(placeMarker);
                }

                function clearPlaceMarkers(type) {
                    if (typeof (placesMarkers[type]) != 'undefined') {
                        for (var key in placesMarkers[type]) {
                            placesMarkers[type][key].setMap(null);
                        }
                        delete placesMarkers[type];
                    }
                }

                function init() {
                    var typesEnabled = _self.POI.split(',');
                    typesEnabled.forEach(function (type) {
                        createPOIItem(type);
                    });
                    buildUI();
                }

                function getPOIItem(type) {
                    if (typeof (type) == 'string') {
                        if (typeof (poiItems[type.toLowerCase()]) != 'undefined')
                            return poiItems[type.toLowerCase()];
                    } else {
                        for (var key in type) {
                            if (typeof (poiItems[type[key].toLowerCase()]) != 'undefined')
                                return poiItems[type[key].toLowerCase()];
                        }

                        for (var key in type) {
                            if (typeof (poiItemsMaster[type[key].toLowerCase()]) != 'undefined')
                                return poiItemsMaster[type[key].toLowerCase()];
                        }
                    }
                    return poiItemsMaster['default'];
                }

                function createPOIItem(type) {
                    var poiItem = getPOIItemFromMaster(type.toLowerCase());
                    if (poiItem != null) {
                        if (typeof (poiItems[poiItem.key]) == 'undefined') {
                            poiItems[poiItem.key] = poiItem;
                            poiItems[poiItem.key].isAllowed = false;
                        }
                    }
                }

                function getPOIItemFromMaster(type) {
                    if (typeof (poiItemsMaster[type]) != 'undefined') {
                        var poiType = poiItemsMaster[type];
                        poiType.key = type;
                        return poiType;
                    }
                    return null;
                }

                function buildUI() {
                    var $close = $('<i data-poi-toggle="" class="aga-close"></i>');
                    $close.on('click', _self.ShowPOI);
                    $close.appendTo(_self.$POIContext);
                    var $poiList = $('<ul></ul>');
                    var parentID = _self.$map.attr('id');
                    for (var key in poiItems)
                        $poiList.append(buildUIPOIItem(poiItems[key], key, parentID));
                    _self.$POIContext.append($poiList);
                }

                function buildUIPOIItem(poi, key, parentID) {

                    var $item = $('<li></li>');
                    var $itemCheck = $('<input id="' + parentID + '_poi_' + key + '" type=\"checkbox\" ' + (poi.isAllowed ? ' checked' : '') + ' value="' + poi.key + '" />');
                    poi.actionItem = $itemCheck;
                    $itemCheck.on('change', function () {
                        enableSearchableViews();
                        poi.isAllowed = $(this)[0].checked;
                        if (poi.isAllowed)
                            search(poi.key);
                        else
                            clearPlaceMarkers(poi.key);
                    });
                    $itemCheck.appendTo($item)
                    $item.append('<label for="' + parentID + '_poi_' + key + '" class="' + poi.key + '"><i class="map-icon ' + poi.icon + '"></i><span>' + poi.label + '</span></label');
                    return $item;
                }


                init();

                return _placeService;
            }

            ///End Definition

            function MarkerWithLabel(opt_options) {
                opt_options = opt_options || {};
                opt_options.labelContent = opt_options.labelContent || "";
                opt_options.labelAnchor = opt_options.labelAnchor || new google.maps.Point(0, 0);
                opt_options.labelClass = opt_options.labelClass || "markerLabels";
                opt_options.labelStyle = opt_options.labelStyle || {};
                opt_options.labelInBackground = opt_options.labelInBackground || false;
                if (typeof opt_options.labelVisible === "undefined") {
                    opt_options.labelVisible = true;
                }
                if (typeof opt_options.raiseOnDrag === "undefined") {
                    opt_options.raiseOnDrag = true;
                }
                if (typeof opt_options.clickable === "undefined") {
                    opt_options.clickable = true;
                }
                if (typeof opt_options.draggable === "undefined") {
                    opt_options.draggable = false;
                }
                if (typeof opt_options.optimized === "undefined") {
                    opt_options.optimized = false;
                }
                opt_options.crossImage = opt_options.crossImage || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/intl/en_us/mapfiles/drag_cross_67_16.png";
                opt_options.handCursor = opt_options.handCursor || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/intl/en_us/mapfiles/closedhand_8_8.cur";
                opt_options.optimized = false; // Optimized rendering is not supported

                this.label = new MarkerLabel_(this, opt_options.crossImage, opt_options.handCursor); // Bind the label to the marker
                google.maps.Marker.apply(this, arguments);
            }

            function inherits(childCtor, parentCtor) {
                function tempCtor() { }
                tempCtor.prototype = parentCtor.prototype;
                childCtor.superClass_ = parentCtor.prototype;
                childCtor.prototype = new tempCtor();
                childCtor.prototype.constructor = childCtor;
            }

            function MarkerLabel_(marker, crossURL, handCursorURL) {
                this.marker_ = marker;
                this.handCursorURL_ = marker.handCursorURL;
                this.labelDiv_ = document.createElement("div");

                this.labelDiv_.style.cssText = "position: absolute; overflow: hidden;";
                this.eventDiv_ = document.createElement("div");
                this.eventDiv_.style.cssText = this.labelDiv_.style.cssText;
                this.eventDiv_.setAttribute("onselectstart", "return false;");
                this.eventDiv_.setAttribute("ondragstart", "return false;");
                this.crossDiv_ = MarkerLabel_.getSharedCross(crossURL);
            }

            inherits(MarkerLabel_, google.maps.OverlayView);
            MarkerLabel_.getSharedCross = function (crossURL) {
                var div;
                if (typeof MarkerLabel_.getSharedCross.crossDiv === "undefined") {
                    div = document.createElement("img");
                    div.style.cssText = "position: absolute; z-index: 1000002; display: none;";
                    div.style.marginLeft = "0px";
                    div.style.marginTop = "0px";
                    div.src = crossURL;
                    MarkerLabel_.getSharedCross.crossDiv = div;
                }
                return MarkerLabel_.getSharedCross.crossDiv;
            };
            MarkerLabel_.prototype.onAdd = function () {
                var me = this;
                var cMouseIsDown = false;
                var cDraggingLabel = false;
                var cSavedZIndex;
                var cLatOffset, cLngOffset;
                var cIgnoreClick;
                var cRaiseEnabled;
                var cStartPosition;
                var cStartCenter;
                var cRaiseOffset = 0;
                var cDraggingCursor = "url(" + this.handCursorURL_ + ")";
                var cAbortEvent = function (e) {
                    if (e.preventDefault) {
                        e.preventDefault();
                    }
                    e.cancelBubble = true;
                    if (e.stopPropagation) {
                        e.stopPropagation();
                    }
                };

                var cStopBounce = function () {
                    me.marker_.setAnimation(null);
                };
                this.getPanes().overlayImage.appendChild(this.labelDiv_);
                this.getPanes().overlayMouseTarget.appendChild(this.eventDiv_);
                if (typeof MarkerLabel_.getSharedCross.processed === "undefined") {
                    this.getPanes().overlayImage.appendChild(this.crossDiv_);
                    MarkerLabel_.getSharedCross.processed = true;
                }
                this.listeners_ = [
                  google.maps.event.addDomListener(this.eventDiv_, "mouseover", function (e) {
                      if (me.marker_.getDraggable() || me.marker_.getClickable()) {
                          this.style.cursor = "pointer";
                          google.maps.event.trigger(me.marker_, "mouseover", e);
                      }
                  }),
                  google.maps.event.addDomListener(this.eventDiv_, "mouseout", function (e) {
                      if ((me.marker_.getDraggable() || me.marker_.getClickable()) && !cDraggingLabel) {
                          this.style.cursor = me.marker_.getCursor();
                          google.maps.event.trigger(me.marker_, "mouseout", e);
                      }
                  }),
                  google.maps.event.addDomListener(this.eventDiv_, "mousedown", function (e) {
                      cDraggingLabel = false;
                      if (me.marker_.getDraggable()) {
                          cMouseIsDown = true;
                          this.style.cursor = cDraggingCursor;
                      }
                      if (me.marker_.getDraggable() || me.marker_.getClickable()) {
                          google.maps.event.trigger(me.marker_, "mousedown", e);
                          cAbortEvent(e); // Prevent map pan when starting a drag on a label
                      }
                  }),
                  google.maps.event.addDomListener(document, "mouseup", function (mEvent) {
                      var position;
                      if (cMouseIsDown) {
                          cMouseIsDown = false;
                          me.eventDiv_.style.cursor = "pointer";
                          google.maps.event.trigger(me.marker_, "mouseup", mEvent);
                      }
                      if (cDraggingLabel) {
                          if (cRaiseEnabled) { // Lower the marker & label
                              position = me.getProjection().fromLatLngToDivPixel(me.marker_.getPosition());
                              position.y += cRaiseOffset;
                              me.marker_.setPosition(me.getProjection().fromDivPixelToLatLng(position));
                              try { // Will fail if running Google Maps API earlier than V3.3
                                  me.marker_.setAnimation(google.maps.Animation.BOUNCE);
                                  setTimeout(cStopBounce, 1406);
                              } catch (e) { }
                          }
                          me.crossDiv_.style.display = "none";
                          me.marker_.setZIndex(cSavedZIndex);
                          cIgnoreClick = true; // Set flag to ignore the click event reported after a label drag
                          cDraggingLabel = false;
                          mEvent.latLng = me.marker_.getPosition();
                          google.maps.event.trigger(me.marker_, "dragend", mEvent);
                      }
                  }),
                  google.maps.event.addListener(me.marker_.getMap(), "mousemove", function (mEvent) {
                      var position;
                      if (cMouseIsDown) {
                          if (cDraggingLabel) {
                              mEvent.latLng = new google.maps.LatLng(mEvent.latLng.lat() - cLatOffset, mEvent.latLng.lng() - cLngOffset);
                              position = me.getProjection().fromLatLngToDivPixel(mEvent.latLng);
                              if (cRaiseEnabled) {
                                  me.crossDiv_.style.left = position.x + "px";
                                  me.crossDiv_.style.top = position.y + "px";
                                  me.crossDiv_.style.display = "";
                                  position.y -= cRaiseOffset;
                              }
                              me.marker_.setPosition(me.getProjection().fromDivPixelToLatLng(position));
                              if (cRaiseEnabled) { // Don't raise the veil; this hack needed to make MSIE act properly
                                  me.eventDiv_.style.top = (position.y + cRaiseOffset) + "px";
                              }
                              google.maps.event.trigger(me.marker_, "drag", mEvent);
                          } else {
                              // Calculate offsets from the click point to the marker position:
                              cLatOffset = mEvent.latLng.lat() - me.marker_.getPosition().lat();
                              cLngOffset = mEvent.latLng.lng() - me.marker_.getPosition().lng();
                              cSavedZIndex = me.marker_.getZIndex();
                              cStartPosition = me.marker_.getPosition();
                              cStartCenter = me.marker_.getMap().getCenter();
                              cRaiseEnabled = me.marker_.get("raiseOnDrag");
                              cDraggingLabel = true;
                              me.marker_.setZIndex(1000000); // Moves the marker & label to the foreground during a drag
                              mEvent.latLng = me.marker_.getPosition();
                              google.maps.event.trigger(me.marker_, "dragstart", mEvent);
                          }
                      }
                  }),
                  google.maps.event.addDomListener(document, "keydown", function (e) {
                      if (cDraggingLabel) {
                          if (e.keyCode === 27) { // Esc key
                              cRaiseEnabled = false;
                              me.marker_.setPosition(cStartPosition);
                              me.marker_.getMap().setCenter(cStartCenter);
                              google.maps.event.trigger(document, "mouseup", e);
                          }
                      }
                  }),
                  google.maps.event.addDomListener(this.eventDiv_, "click", function (e) {
                      if (me.marker_.getDraggable() || me.marker_.getClickable()) {
                          if (cIgnoreClick) { // Ignore the click reported when a label drag ends
                              cIgnoreClick = false;
                          } else {
                              google.maps.event.trigger(me.marker_, "click", e);
                              cAbortEvent(e); // Prevent click from being passed on to map
                          }
                      }
                  }),
                  google.maps.event.addDomListener(this.eventDiv_, "dblclick", function (e) {
                      if (me.marker_.getDraggable() || me.marker_.getClickable()) {
                          google.maps.event.trigger(me.marker_, "dblclick", e);
                          cAbortEvent(e); // Prevent map zoom when double-clicking on a label
                      }
                  }),
                  google.maps.event.addListener(this.marker_, "dragstart", function (mEvent) {
                      if (!cDraggingLabel) {
                          cRaiseEnabled = this.get("raiseOnDrag");
                      }
                  }),
                  google.maps.event.addListener(this.marker_, "drag", function (mEvent) {
                      if (!cDraggingLabel) {
                          if (cRaiseEnabled) {
                              me.setPosition(cRaiseOffset);
                              me.labelDiv_.style.zIndex = 1000000 + (this.get("labelInBackground") ? -1 : +1);
                          }
                      }
                  }),
                  google.maps.event.addListener(this.marker_, "dragend", function (mEvent) {
                      if (!cDraggingLabel) {
                          if (cRaiseEnabled) {
                              me.setPosition(0); // Also restores z-index of label
                          }
                      }
                  }),
                  google.maps.event.addListener(this.marker_, "position_changed", function () {
                      me.setPosition();
                  }),
                  google.maps.event.addListener(this.marker_, "zindex_changed", function () {
                      me.setZIndex();
                  }),
                  google.maps.event.addListener(this.marker_, "visible_changed", function () {
                      me.setVisible();
                  }),
                  google.maps.event.addListener(this.marker_, "labelvisible_changed", function () {
                      me.setVisible();
                  }),
                  google.maps.event.addListener(this.marker_, "title_changed", function () {
                      me.setTitle();
                  }),
                  google.maps.event.addListener(this.marker_, "labelcontent_changed", function () {
                      me.setContent();
                  }),
                  google.maps.event.addListener(this.marker_, "labelanchor_changed", function () {
                      me.setAnchor();
                  }),
                  google.maps.event.addListener(this.marker_, "labelclass_changed", function () {
                      me.setStyles();
                  }),
                  google.maps.event.addListener(this.marker_, "labelstyle_changed", function () {
                      me.setStyles();
                  })
                ];
            };

            MarkerLabel_.prototype.onRemove = function () {
                var i;
                this.labelDiv_.parentNode.removeChild(this.labelDiv_);
                this.eventDiv_.parentNode.removeChild(this.eventDiv_);

                for (i = 0; i < this.listeners_.length; i++) {
                    google.maps.event.removeListener(this.listeners_[i]);
                }
            };
            MarkerLabel_.prototype.draw = function () {
                this.setContent();
                this.setTitle();
                this.setStyles();
            };
            MarkerLabel_.prototype.setContent = function () {
                var content = this.marker_.get("labelContent");
                if (typeof content.nodeType === "undefined") {
                    this.labelDiv_.innerHTML = '<span class="content">' + content + '</span>';
                    this.eventDiv_.innerHTML = this.labelDiv_.innerHTML;
                } else {
                    this.labelDiv_.innerHTML = ""; // Remove current content
                    this.labelDiv_.appendChild('<span class="content">' + content + '</span>');
                    content = content.cloneNode(true);
                    this.eventDiv_.appendChild(content);
                }
            };

            MarkerLabel_.prototype.setTitle = function () {
                this.eventDiv_.title = this.marker_.getTitle() || "";
            };

            MarkerLabel_.prototype.setStyles = function () {
                var i, labelStyle;
                this.labelDiv_.className = this.marker_.get("labelClass");
                this.eventDiv_.className = this.labelDiv_.className;
                this.labelDiv_.style.cssText = "";
                this.eventDiv_.style.cssText = "";
                labelStyle = this.marker_.get("labelStyle");
                for (i in labelStyle) {
                    if (labelStyle.hasOwnProperty(i)) {
                        this.labelDiv_.style[i] = labelStyle[i];
                        this.eventDiv_.style[i] = labelStyle[i];
                    }
                }
                this.setMandatoryStyles();
            };
            MarkerLabel_.prototype.setMandatoryStyles = function () {
                this.labelDiv_.style.position = "absolute";
                this.labelDiv_.style.overflow = "hidden";
                if (typeof this.labelDiv_.style.opacity !== "undefined" && this.labelDiv_.style.opacity !== "") {
                    this.labelDiv_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(opacity=" + (this.labelDiv_.style.opacity * 100) + ")\"";
                    this.labelDiv_.style.filter = "alpha(opacity=" + (this.labelDiv_.style.opacity * 100) + ")";
                }
                this.eventDiv_.style.position = this.labelDiv_.style.position;
                this.eventDiv_.style.overflow = this.labelDiv_.style.overflow;
                this.eventDiv_.style.opacity = 0.01; // Don't use 0; DIV won't be clickable on MSIE
                this.eventDiv_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(opacity=1)\"";
                this.eventDiv_.style.filter = "alpha(opacity=1)"; // For MSIE

                this.setAnchor();
                this.setPosition(); // This also updates z-index, if necessary.
                this.setVisible();
            };

            MarkerLabel_.prototype.setAnchor = function () {
                var anchor = this.marker_.get("labelAnchor");
                this.labelDiv_.style.marginLeft = -anchor.x + "px";
                this.labelDiv_.style.marginTop = -anchor.y + "px";
                this.eventDiv_.style.marginLeft = -anchor.x + "px";
                this.eventDiv_.style.marginTop = -anchor.y + "px";
            };

            MarkerLabel_.prototype.setPosition = function (yOffset) {
                var position = this.getProjection().fromLatLngToDivPixel(this.marker_.getPosition());
                if (typeof yOffset === "undefined") {
                    yOffset = 0;
                }
                this.labelDiv_.style.left = Math.round(position.x) + "px";
                this.labelDiv_.style.top = Math.round(position.y - yOffset) + "px";
                this.eventDiv_.style.left = this.labelDiv_.style.left;
                this.eventDiv_.style.top = this.labelDiv_.style.top;

                this.setZIndex();
            };

            MarkerLabel_.prototype.setZIndex = function () {
                var zAdjust = (this.marker_.get("labelInBackground") ? -1 : +1);
                if (typeof this.marker_.getZIndex() === "undefined") {
                    this.labelDiv_.style.zIndex = parseInt(this.labelDiv_.style.top, 10) + zAdjust;
                    this.eventDiv_.style.zIndex = this.labelDiv_.style.zIndex;
                } else {
                    this.labelDiv_.style.zIndex = this.marker_.getZIndex() + zAdjust;
                    this.eventDiv_.style.zIndex = this.labelDiv_.style.zIndex;
                }
            };

            MarkerLabel_.prototype.setVisible = function () {
                if (this.marker_.get("labelVisible")) {
                    this.labelDiv_.style.display = this.marker_.getVisible() ? "block" : "none";
                } else {
                    this.labelDiv_.style.display = "none";
                }
                this.eventDiv_.style.display = this.labelDiv_.style.display;
            };

            inherits(MarkerWithLabel, google.maps.Marker);
            MarkerWithLabel.prototype.setMap = function (theMap) {

                // Call the inherited function...
                google.maps.Marker.prototype.setMap.apply(this, arguments);

                // ... then deal with the label:
                this.label.setMap(theMap);
            };

            //logger.log(_self.IsInitialized);
            _self.initialize();

            _self.$map.data('AreaMap', _self);
            return _self;
        };
    };

}(jQuery));